import React from 'react';
import { useDispatch } from 'react-redux';
import { SystemText } from '@salesperformanceint/e4shared';
import { setPrismMenu } from 'actions/ui';
import CourseLibrary from 'views/courseLibrary';

const kinds = ['roleplayai'];

const st = (path, ...rest) => SystemText(`CourseLibrary/AIRoleplay/${path}`, ...rest);

export const CourseLibraryRoleplayAi = () => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setPrismMenu('CourseLibraryRolePlay'));
    }, []);

    return <CourseLibrary kinds={kinds} systemTextFunction={st} />;
};

export default CourseLibraryRoleplayAi;
